module.exports = __webpack_public_path__ + "img/shekaiat_logo.7761be08.png";